import React from 'react';

/**
 * ProgressBar — Barre de progression avec pourcentage
 * Utilisé pour afficher l'avancement d'une opération de transport.
 *
 * Props:
 *   step: number  (0..total)
 *   total: number (par défaut 6)
 *   showPercent?: boolean (par défaut true)
 *   variant?: 'auto' | 'success' | 'danger'
 */
const ProgressBar = ({ step = 0, total = 6, showPercent = true, variant = 'auto' }) => {
  const isCancelled = step === -1;
  const safeStep = Math.max(0, Math.min(step, total));
  const pct = isCancelled ? 0 : Math.round((safeStep / total) * 100);

  let barColor = 'bg-emerald-500';
  if (variant === 'danger' || isCancelled) barColor = 'bg-red-400';
  else if (pct >= 100) barColor = 'bg-emerald-600';
  else if (pct >= 50) barColor = 'bg-emerald-500';
  else if (pct > 0) barColor = 'bg-amber-400';
  else barColor = 'bg-zinc-300';

  return (
    <div className="flex items-center gap-2 min-w-[80px]">
      <div className="flex-1 h-1.5 bg-zinc-100 rounded-full overflow-hidden">
        <div
          className={`h-full ${barColor} rounded-full transition-all duration-500 ease-out`}
          style={{ width: isCancelled ? '100%' : `${pct}%` }}
        />
      </div>
      {showPercent && (
        <span
          className={`text-[10px] font-semibold tabular-nums ${
            isCancelled ? 'text-red-500' : pct >= 100 ? 'text-emerald-600' : 'text-zinc-500'
          }`}
          style={{ fontFamily: "'JetBrains Mono', monospace", minWidth: '28px', textAlign: 'right' }}
        >
          {isCancelled ? '–' : `${pct}%`}
        </span>
      )}
    </div>
  );
};

export default ProgressBar;
